export const SECTION_STACK_GAP = 2.5;

export const SHELL_GEOMETRY = Object.freeze({
  fullBleed: "fullBleed",
  card: "card",
  edge: "edge",
});

// Page-shell sx for a spec's `shell` block. fullBleed = none (theme page gutters); edge = no gutters or padding (installed-app screens);
// card = a single centred column at the onboarding card width (breadcrumb stays in the shell gutter).
export function shellSxFromSpec(shell) {
  switch (shell?.geometry) {
    case SHELL_GEOMETRY.card:
      return null;
    case SHELL_GEOMETRY.edge:
      return { px: 0, pt: 0, pb: 0 };
    default:
      return null;
  }
}

// Body-column sx for `card` geometry — applied around the body, not the shell, so slot ① keeps the gutter.
export function shellBodySxFromSpec(shell) {
  if (shell?.geometry !== SHELL_GEOMETRY.card) return null;
  return {
    width: "100%",
    maxWidth: shell.maxWidth ?? ((theme) => theme.palette.layout.onboardingCardMaxWidth),
    mx: "auto",
  };
}
